<button mat-button class="export-button" (click)="openDialog()">
  <span class="material-symbols-outlined">download</span>
  <span>Export</span>
</button>
